import { IStatisticsApi, IResponse } from './types';
import { AxiosInstance } from 'axios';
import { Statistics, StatisticsPeriod } from '../statistics/types';

class StatisticsApi implements IStatisticsApi {
  constructor(
    private readonly axios: AxiosInstance,
    private readonly apiUrl: string = '/statistics'
  ) {}

  load = async (websiteId: string, period: StatisticsPeriod) => {
    const res: IResponse<Statistics> = { response: null, error: null };

    try {
      const { data } = await this.axios.get(
        `${this.apiUrl}/${websiteId}/${period}`
      );

      res.response = data;
    } catch (e) {
      res.error = e;
    }

    return res;
  };
}

export default StatisticsApi;
